module.exports = __webpack_public_path__ + "media/images/menu/orion-d29b5f5d20891fdd304abcd3c6040cd7.jpg";